/** @format */
import React, { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

import { GridRepeater } from '@toucan/client/shared/components/grid-repeater';

import { StoryCard } from '@toucan/client/features/contentful/components/story-card';

import { styles } from './story-card-collection.styles';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type StoryCardCollectionProps = {
    children?: ReactNode;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    loading?: boolean;
    skeletonCount?: number;
    columnCount?: number;
    'data-testid'?: string;
    className?: string;
    'data-id'?: string;
};

const StyledStoryCardCollection = styled.div`
    ${styles}
`;

export const StoryCardCollection: FunctionComponent<
    StoryCardCollectionProps
> = ({
    loading,
    skeletonCount = 3,
    columnCount = 1,
    children,
    'data-id': dataId = 'story-card-collection',
    ...otherProps
}: StoryCardCollectionProps) => {
    function renderSkeleton(): ReactNode {
        return Array(skeletonCount)
            .fill(null)
            .map((_, index) => (
                <StoryCard
                    loading={true}
                    // eslint-disable-next-line react/no-array-index-key -- Legacy code: do not use as an example.
                    key={index}
                    data-testid="story-card-collection__skeleton"
                    data-id={`${dataId}__skeleton-${index}`}
                />
            ));
    }

    return (
        <StyledStoryCardCollection {...otherProps} data-id={dataId}>
            <GridRepeater
                gridColumns={columnCount}
                data-testid={`article-results__grid${
                    loading ? '-loading' : ''
                }`}
                gridGap="var(--layout-spacing-24)"
                data-id={`${dataId}__container`}
            >
                {loading ? renderSkeleton() : children}
            </GridRepeater>
        </StyledStoryCardCollection>
    );
};
